import BenefitsChart from './benefits_chart';

class BenefitsChartValue extends BenefitsChart {
  custom_pie_chart_options() {
    return {
      chart: {
        height: (this.is_pdf() ? 400 : 300),
        spacingLeft: 10 // setting this stops the chart from "jumping" in Chrome if you resize the window
      },
      legend: {
        enabled: (this.is_pdf() ? this.model.chart_pdf_value_legend_enabled() : this.model.chart_value_legend_enabled()),
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'middle',
        padding: 15,
        x: 5
      },
      plotOptions: {
        pie: {
          size: (this.is_pdf() ? 225 : 180),
          startAngle: (this.$container.data('benefits-chart-start-angle') === 'undefined') ? 0 : this.$container.data('benefits-chart-start-angle')
        }
      },
      responsive: {
        rules: [{
          condition: {
            maxWidth: 560
          },
          chartOptions: {
            legend: {
              align: 'center',
              layout: 'horizontal',
              verticalAlign: 'bottom',
              x: 5,
            }
          }
        }]
      },
    };
  }
}

export default BenefitsChartValue;
